var Vue = require('vue');
var StandaloneUploader = require('../../lib/standalone-uploader.js');
var AutoSaver = require('autosaver');
var Audio = require('../../lib/audio.js');
var VideoPlayer = require('../../lib/video-player.js');
var VideoModal = require('../../lib/video-modal.js');
var VideoThumbnails = require('../../lib/video-thumbnails.js');
var toastr = require('../../lib/tectoastr');
var TableField = require('../../lib/components/Fields/TableField.vue').default;

module.exports = function() {
    // Setup standalone uploader (for file fields).
    new StandaloneUploader;

    // Autosaver
    var autosaver = new AutoSaver($('form.autosave'));
    autosaver.setSupressWarnings(true);

    // Save actionTaken value
    $('.review-task-form button[value="proceed"], .review-task-form button[value="stop"]').on('click', function (event) {
        event.preventDefault();
        $('#actionTaken').val($(this).val());
        autosaver.saveSubmit();
    });

    // Save for later
    var saveForLater = function () {
        autosaver.save();
        toastr.success($('#review-saved').html());
    };

    $('.review-task-form button[value="save"]').on('click', function (event) {
        event.preventDefault();
        saveForLater();
    });

    // Audio
    var audio = new Audio;
    audio.setup('jp-jplayer');

    // Video
    var videoPlayer = new VideoPlayer;
    var videoModal = new VideoModal;
    var videoThumbnails = new VideoThumbnails;

    videoPlayer.setup('video-js-standalone');
    videoModal.setup('play-video');
    videoThumbnails.setup('preview-container.video');

    // Initialise table fields
    let tableFields = document.getElementsByClassName('table-field-input-container');

    for (let i = 0; i < tableFields.length; i++) {
        new Vue({
            el: tableFields[i],
            components: {
                'table-field': TableField
            },
            provide: function() {
                return {
                    lang: {
                        locale: App.languageCode
                    }
                };
            }
        });
    }
};
